import i18n from '@link/share/i18n';

const ABSOLUTE_URL_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//;

const hasProtocol = (path: string): boolean => {
  return ABSOLUTE_URL_PATTERN.test(path) || path.startsWith('//');
};

const isAlreadyLocalized = (path: string, lang: string): boolean => {
  return path === lang || path.startsWith(`${lang}/`);
};

const normalizePath = (path: string): string => {
  return path.replace(/^\/+/, '');
};

/**
 * Prefix a relative path with the current locale segment (e.g. /ja/terms).
 * Absolute URLs and protocol-relative URLs are returned as-is.
 */
export const buildLocalizedPath = (path: string = ''): string => {
  const lang = i18n.language;
  const trimmedPath = path.trim();

  if (!trimmedPath || trimmedPath === '/') {
    return `/${lang}`;
  }

  if (hasProtocol(trimmedPath)) {
    return trimmedPath;
  }

  if (trimmedPath.startsWith('?') || trimmedPath.startsWith('#')) {
    return `/${lang}${trimmedPath}`;
  }

  const normalized = normalizePath(trimmedPath);

  if (!normalized) {
    return `/${lang}`;
  }

  if (isAlreadyLocalized(normalized, lang)) {
    return `/${normalized}`;
  }

  return `/${lang}/${normalized}`;
};
